/**
 * 微短剧剧集数据（演示用静态数据）
 * cover：3:4 竖版海报，已包含 width / height 元信息，渲染时需显式声明尺寸
 */

export type Drama = {
  id: string;
  title: string;
  category: string;
  region: string;
  year: string;
  status: "连载中" | "已完结";
  episodes: number;
  updatedEpisode: number;
  badge: string;
  exclusive: boolean;
  rating: number;
  views: string;
  viewsNumber: number;
  tags: string[];
  director: string;
  cast: string[];
  synopsis: string;
  cover: string;
  publishedAt: string;
};

export const dramas: Drama[] = [
  {
    id: "ceo-substitute-bride",
    title: "总裁的替身新娘",
    category: "ceo",
    region: "mainland",
    year: "2026",
    status: "已完结",
    episodes: 92,
    updatedEpisode: 92,
    badge: "92集全",
    exclusive: true,
    rating: 9.4,
    views: "3.8亿",
    viewsNumber: 380000000,
    tags: ["替身文学", "先婚后爱", "豪门", "追妻火葬场"],
    director: "程砚舟",
    cast: ["沈知夏", "陆时衍", "林清越"],
    synopsis:
      "一场替嫁，让平凡女孩沈知夏成了冷面总裁陆时衍的挂名妻子。她以为这只是一纸三年契约，却在一次次危机中被他亲手护住。当真正的白月光归国，替身的身份被撕开，陆时衍才发现自己早已沦陷。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20vertical%20poster%2C%20cold%20handsome%20East%20Asian%20CEO%20in%20black%20tailored%20suit%20standing%20in%20a%20glass%20office%20tower%20at%20midnight%2C%20amber%20rim%20light%2C%20elegant%20bride%20in%20crimson%20gown%20reflected%20in%20the%20window%2C%20moody%20noir%20atmosphere%2C%20premium%20streaming%20drama%20key%20art%2C%20ultra%20detailed%20cinematic%20lighting&width=600&height=800&seq=drama-ceo-substitute-bride&orientation=portrait",
    publishedAt: "2026-10-21",
  },
  {
    id: "city-war-god",
    title: "我在都市当战神",
    category: "city",
    region: "mainland",
    year: "2026",
    status: "连载中",
    episodes: 100,
    updatedEpisode: 48,
    badge: "更新至48集",
    exclusive: true,
    rating: 9.2,
    views: "2.6亿",
    viewsNumber: 260000000,
    tags: ["扮猪吃虎", "热血", "身份反转", "兄弟情"],
    director: "韩牧",
    cast: ["江彻", "许南星", "傅铮"],
    synopsis:
      "五年前他被逐出家门，五年后他带着一身战功归来。白天的他是街角修车铺的普通师傅，夜晚的他却是让整个地下世界低头的战神。当昔日仇人再度伸手，他决定把这盘棋彻底掀翻。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20vertical%20poster%2C%20muscular%20East%20Asian%20man%20in%20black%20tactical%20coat%20standing%20in%20a%20rainy%20neon%20city%20street%2C%20golden%20streetlight%20reflections%20on%20wet%20asphalt%2C%20skyline%20silhouette%2C%20dramatic%20low%20angle%2C%20gritty%20urban%20action%20drama%20key%20art&width=600&height=800&seq=drama-city-war-god&orientation=portrait",
    publishedAt: "2026-10-30",
  },
  {
    id: "war-god-return",
    title: "战神归来之王者无双",
    category: "war",
    region: "mainland",
    year: "2025",
    status: "已完结",
    episodes: 88,
    updatedEpisode: 88,
    badge: "独家",
    exclusive: true,
    rating: 9.1,
    views: "5.1亿",
    viewsNumber: 510000000,
    tags: ["铁血", "家国", "王者归来", "燃向"],
    director: "萧执",
    cast: ["顾寒山", "苏若雪", "夜骁"],
    synopsis:
      "北境十年，他一人挡住百万铁骑；回京一日，他只想护住病榻上的妹妹。可当年的旧案、被篡改的军功、被夺走的姓氏，都在逼他重新披甲。这一次，他不再为谁而战，只为自己讨回公道。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20vertical%20poster%2C%20battle%20worn%20warrior%20in%20ancient%20Chinese%20black%20armor%20standing%20on%20a%20cliff%2C%20burning%20battlefield%20and%20army%20banners%20behind%2C%20embers%20floating%20in%20the%20air%2C%20gold%20and%20crimson%20light%2C%20epic%20historical%20war%20drama%20key%20art%20portrait&width=600&height=800&seq=drama-war-god-return&orientation=portrait",
    publishedAt: "2025-12-12",
  },
  {
    id: "sweet-little-wife",
    title: "甜宠小娇妻",
    category: "sweet",
    region: "mainland",
    year: "2026",
    status: "连载中",
    episodes: 80,
    updatedEpisode: 62,
    badge: "更新至62集",
    exclusive: false,
    rating: 8.9,
    views: "1.9亿",
    viewsNumber: 190000000,
    tags: ["先婚后爱", "日常甜", "双向奔赴", "治愈"],
    director: "温以宁",
    cast: ["苏晚晚", "裴云深", "何知遇"],
    synopsis:
      "被家里催婚的苏晚晚，随手在民政局门口拉了个人领证。她以为对方只是个普通上班族，没想到这位先生会做饭、会哄睡、会在她加班的深夜把车停在楼下等三小时。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20romantic%20vertical%20poster%2C%20young%20couple%20in%20a%20softly%20candlelit%20modern%20apartment%2C%20woman%20in%20cream%20knit%20sweater%20laughing%2C%20man%20in%20charcoal%20shirt%20looking%20at%20her%2C%20warm%20amber%20bokeh%20lights%2C%20intimate%20cinematic%20romance%20drama%20key%20art&width=600&height=800&seq=drama-sweet-little-wife&orientation=portrait",
    publishedAt: "2026-10-27",
  },
  {
    id: "reborn-revenge-heiress",
    title: "重生之复仇千金",
    category: "revenge",
    region: "mainland",
    year: "2026",
    status: "已完结",
    episodes: 96,
    updatedEpisode: 96,
    badge: "96集全",
    exclusive: true,
    rating: 9.5,
    views: "4.4亿",
    viewsNumber: 440000000,
    tags: ["重生", "复仇", "打脸", "大女主"],
    director: "宁未晞",
    cast: ["姜黎", "傅西辞", "沈曼"],
    synopsis:
      "被继母与妹妹联手害死后，姜黎在婚礼当天重生回到十八岁。她记得每一张虚伪的笑脸，也记得那场大火。这一世，她要把属于自己的东西一件件拿回来，包括那个前世为她收尸的男人。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20dramatic%20vertical%20poster%2C%20elegant%20East%20Asian%20woman%20in%20a%20black%20evening%20gown%20holding%20a%20folding%20fan%2C%20mirrored%20ballroom%20with%20crimson%20curtains%2C%20sharp%20rim%20lighting%2C%20revenge%20drama%20key%20art%2C%20luxurious%20noir%20mood%2C%20ultra%20detailed&width=600&height=800&seq=drama-reborn-revenge-heiress&orientation=portrait",
    publishedAt: "2026-09-18",
  },
  {
    id: "transmigrated-princess",
    title: "穿越成王妃",
    category: "ancient",
    region: "mainland",
    year: "2025",
    status: "已完结",
    episodes: 78,
    updatedEpisode: 78,
    badge: "78集全",
    exclusive: false,
    rating: 8.7,
    views: "1.5亿",
    viewsNumber: 150000000,
    tags: ["穿越", "宫廷", "智斗", "双强"],
    director: "白知远",
    cast: ["云初", "萧景珩", "柳嫣然"],
    synopsis:
      "现代法医云初一场意外穿成大梁不受宠的庶女，被塞进王府当棋子。她凭一手验尸绝技破了三桩悬案，也顺手把冷面王爷的心剖得干干净净。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20vertical%20poster%2C%20ancient%20Chinese%20palace%20corridor%20at%20night%2C%20noblewoman%20in%20embroidered%20hanfu%20with%20jade%20hairpin%2C%20moonlight%20through%20lattice%20window%2C%20crimson%20lantern%20glow%2C%20historical%20fantasy%20drama%20key%20art&width=600&height=800&seq=drama-transmigrated-princess&orientation=portrait",
    publishedAt: "2025-11-06",
  },
  {
    id: "secret-husband-boss",
    title: "隐婚老公是大佬",
    category: "ceo",
    region: "mainland",
    year: "2026",
    status: "连载中",
    episodes: 84,
    updatedEpisode: 35,
    badge: "更新至35集",
    exclusive: false,
    rating: 8.8,
    views: "1.2亿",
    viewsNumber: 120000000,
    tags: ["隐婚", "马甲", "豪门", "轻喜"],
    director: "顾南舟",
    cast: ["温书意", "厉行川", "唐诗"],
    synopsis:
      "温书意结婚三年只见过丈夫三面，直到公司被收购，她在董事会上看见那个坐在主位的男人——正是她那位“普通程序员”老公。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20vertical%20poster%2C%20mysterious%20man%20in%20black%20coat%20and%20leather%20gloves%20stepping%20out%20of%20a%20luxury%20car%20at%20night%2C%20rain%20on%20asphalt%2C%20gold%20light%20spill%2C%20woman%20silhouette%20behind%20glass%2C%20urban%20romance%20drama%20key%20art&width=600&height=800&seq=drama-secret-husband-boss&orientation=portrait",
    publishedAt: "2026-10-15",
  },
  {
    id: "abandoned-daughter-return",
    title: "弃女归来",
    category: "revenge",
    region: "mainland",
    year: "2025",
    status: "已完结",
    episodes: 90,
    updatedEpisode: 90,
    badge: "90集全",
    exclusive: false,
    rating: 9.0,
    views: "2.2亿",
    viewsNumber: 220000000,
    tags: ["逆袭", "商战", "亲情", "大女主"],
    director: "陆知白",
    cast: ["宋屿", "沈砚清", "宋母"],
    synopsis:
      "被亲生父母遗弃在乡下的宋屿，二十年后带着一家上市公司回到那座城市。她没有歇斯底里，只是安静地坐在谈判桌对面，看着当年签下弃养书的人手心冒汗。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20vertical%20poster%2C%20confident%20East%20Asian%20businesswoman%20in%20ivory%20suit%20standing%20in%20a%20corporate%20boardroom%2C%20floor%20to%20ceiling%20windows%20with%20night%20city%2C%20cool%20shadows%20with%20warm%20gold%20highlights%2C%20revenge%20drama%20key%20art&width=600&height=800&seq=drama-abandoned-daughter-return&orientation=portrait",
    publishedAt: "2025-10-02",
  },
  {
    id: "eighties-hot-wife",
    title: "八零辣妻",
    category: "era",
    region: "mainland",
    year: "2025",
    status: "已完结",
    episodes: 76,
    updatedEpisode: 76,
    badge: "76集全",
    exclusive: false,
    rating: 8.6,
    views: "9800万",
    viewsNumber: 98000000,
    tags: ["年代", "励志", "创业", "烟火气"],
    director: "苏禾",
    cast: ["赵小满", "周正阳", "李巧云"],
    synopsis:
      "一觉醒来，赵小满成了八十年代农机厂的辣妹子。面对偏心婆家和下岗风潮，她摆摊、开厂、带着全村一起挣钱，还顺手把闷葫芦丈夫哄成了模范老公。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20vertical%20poster%2C%201980s%20Chinese%20small%20town%20street%20at%20dusk%2C%20young%20woman%20in%20a%20floral%20dress%20with%20a%20bicycle%2C%20retro%20painted%20wall%20slogans%2C%20golden%20dusty%20sunlight%2C%20vintage%20film%20grain%2C%20family%20drama%20key%20art&width=600&height=800&seq=drama-eighties-hot-wife&orientation=portrait",
    publishedAt: "2025-08-14",
  },
  {
    id: "my-disciples-are-bosses",
    title: "我的徒弟都是大佬",
    category: "ancient",
    region: "mainland",
    year: "2026",
    status: "连载中",
    episodes: 100,
    updatedEpisode: 71,
    badge: "更新至71集",
    exclusive: true,
    rating: 9.0,
    views: "1.7亿",
    viewsNumber: 170000000,
    tags: ["武侠", "师生", "轻喜", "群像"],
    director: "墨山",
    cast: ["谢无咎", "沈墨白", "小满"],
    synopsis:
      "落魄剑客谢无咎在山门前收了四个徒弟，教他们练剑、做饭、写检讨。十年后徒弟们各自成了一方大佬，却还是要按时回山门吃师父煮的面。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20fantasy%20vertical%20poster%2C%20mysterious%20old%20master%20in%20a%20grey%20robe%20on%20a%20mountain%20peak%2C%20disciples%20in%20martial%20arts%20robes%20silhouetted%20behind%2C%20swirling%20clouds%2C%20teal%20and%20gold%20mist%2C%20wuxia%20drama%20key%20art&width=600&height=800&seq=drama-my-disciples-are-bosses&orientation=portrait",
    publishedAt: "2026-10-24",
  },
  {
    id: "midnight-rose",
    title: "深夜玫瑰",
    category: "sweet",
    region: "hk",
    year: "2025",
    status: "已完结",
    episodes: 64,
    updatedEpisode: 64,
    badge: "64集全",
    exclusive: false,
    rating: 8.5,
    views: "7600万",
    viewsNumber: 76000000,
    tags: ["都市", "悬疑爱情", "宿命", "港风"],
    director: "陈嘉树",
    cast: ["苏玫瑰", "程亦", "阿七"],
    synopsis:
      "每晚十一点，她都会坐在同一家爵士酒吧的角落。有人说她在等人，有人说她在等一个答案。直到那个带着旧伤的男人推门进来，所有唱片都停在了同一句歌词上。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20noir%20vertical%20poster%2C%20elegant%20woman%20in%20a%20burgundy%20slip%20dress%20in%20a%20smoky%20jazz%20bar%2C%20chandelier%20bokeh%2C%20man%20in%20tuxedo%20in%20shadow%2C%20crimson%20and%20amber%20lighting%2C%20romantic%20thriller%20key%20art&width=600&height=800&seq=drama-midnight-rose&orientation=portrait",
    publishedAt: "2025-07-19",
  },
  {
    id: "ace-bodyguard",
    title: "王牌保镖",
    category: "city",
    region: "mainland",
    year: "2026",
    status: "连载中",
    episodes: 88,
    updatedEpisode: 44,
    badge: "更新至44集",
    exclusive: false,
    rating: 8.4,
    views: "1.1亿",
    viewsNumber: 110000000,
    tags: ["动作", "护花", "身份谜团", "爽剧"],
    director: "雷戈",
    cast: ["秦戈", "白若溪", "老K"],
    synopsis:
      "退役特种兵秦戈接下一单护卫任务，保护对象是个麻烦不断的大小姐。他以为自己只是拿钱办事，直到发现追杀她的人，正是当年害死自己小队的幕后黑手。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20action%20vertical%20poster%2C%20suited%20bodyguard%20with%20earpiece%20shielding%20a%20young%20heiress%2C%20underground%20parking%20garage%2C%20harsh%20headlights%2C%20sparks%20in%20the%20air%2C%20high%20contrast%20noir%20action%20drama%20key%20art&width=600&height=800&seq=drama-ace-bodyguard&orientation=portrait",
    publishedAt: "2026-10-11",
  },
  {
    id: "heiress-comeback",
    title: "逆袭千金",
    category: "ceo",
    region: "mainland",
    year: "2024",
    status: "已完结",
    episodes: 82,
    updatedEpisode: 82,
    badge: "82集全",
    exclusive: false,
    rating: 8.3,
    views: "8900万",
    viewsNumber: 89000000,
    tags: ["豪门", "真假千金", "打脸", "时尚"],
    director: "林嘉禾",
    cast: ["顾念", "傅时野", "顾薇薇"],
    synopsis:
      "一场亲子鉴定，让顾念从佣人的女儿变回顾家大小姐。可那个占了她位置十八年的女孩，却在她回归的晚宴上笑得很甜。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20glamorous%20vertical%20poster%2C%20young%20woman%20in%20an%20emerald%20gown%20descending%20a%20marble%20staircase%2C%20paparrazi%20flash%20lights%2C%20luxurious%20hotel%20lobby%2C%20gold%20accents%2C%20comeback%20drama%20key%20art%2C%20cinematic%20depth&width=600&height=800&seq=drama-heiress-comeback&orientation=portrait",
    publishedAt: "2024-12-05",
  },
  {
    id: "ancient-noodle-house",
    title: "我在古代开饭馆",
    category: "ancient",
    region: "mainland",
    year: "2026",
    status: "连载中",
    episodes: 72,
    updatedEpisode: 28,
    badge: "更新至28集",
    exclusive: false,
    rating: 8.9,
    views: "9300万",
    viewsNumber: 93000000,
    tags: ["美食", "穿越", "治愈", "轻喜"],
    director: "叶青",
    cast: ["林小满", "裴七郎", "阿福"],
    synopsis:
      "五星大厨林小满穿成古代小寡妇，接手一间快要倒闭的面馆。她从一碗阳春面做起，把整条长街的生意都带火了，也把隔壁那位冷面捕头喂成了常客。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20vertical%20poster%2C%20ancient%20Chinese%20street%20food%20stall%20at%20night%2C%20steaming%20bamboo%20baskets%2C%20red%20lanterns%2C%20young%20woman%20in%20simple%20hanfu%20smiling%2C%20cozy%20golden%20light%2C%20costume%20comedy%20drama%20key%20art&width=600&height=800&seq=drama-ancient-noodle-house&orientation=portrait",
    publishedAt: "2026-10-29",
  },
  {
    id: "ceo-wife-vest",
    title: "总裁夫人马甲又掉了",
    category: "ceo",
    region: "mainland",
    year: "2025",
    status: "已完结",
    episodes: 86,
    updatedEpisode: 86,
    badge: "86集全",
    exclusive: true,
    rating: 8.7,
    views: "1.6亿",
    viewsNumber: 160000000,
    tags: ["马甲", "双强", "轻喜", "打脸"],
    director: "周砚",
    cast: ["南乔", "霍沉", "南星"],
    synopsis:
      "霍沉以为自己娶了个只会撒娇的小妻子，直到他在世界黑客大赛的冠军名单上看见她的名字，在赛车场看见她的车号，在拍卖行看见她举牌的手。",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20dark%20vertical%20poster%2C%20stylish%20East%20Asian%20woman%20in%20black%20leather%20jacket%20and%20sunglasses%20in%20an%20underground%20garage%2C%20luxury%20sports%20car%2C%20confident%20smirk%2C%20neon%20rim%20light%2C%20urban%20comedy%20drama%20key%20art&width=600&height=800&seq=drama-ceo-wife-vest&orientation=portrait",
    publishedAt: "2025-09-22",
  },
  {
    id: "jianghu-outlaws",
    title: "江湖不良人",
    category: "suspense",
    region: "mainland",
    year: "2025",
    status: "已完结",
    episodes: 68,
    updatedEpisode: 68,
    badge: "68集全",
    exclusive: false,
    rating: 9.2,
    views: "1.3亿",
    viewsNumber: 130000000,
    tags: ["武侠悬疑", "群像", "反转", "江湖"],
    director: "沈墨",
    cast: ["陆行舟", "苏青", "崔九"],
    synopsis:
      "一桩灭门案，把三个身份迥异的江湖人绑在一起。追查真相的路上，他们发现彼此的师父、仇人、甚至姓名，都指向同一个被抹去的夜晚。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20wuxia%20vertical%20poster%2C%20swordsman%20in%20a%20dark%20cloak%20and%20straw%20hat%20standing%20in%20a%20bamboo%20forest%20at%20night%2C%20falling%20leaves%2C%20silver%20moonlight%2C%20crimson%20sash%2C%20ink%20wash%20cinematic%20key%20art&width=600&height=800&seq=drama-jianghu-outlaws&orientation=portrait",
    publishedAt: "2025-06-30",
  },
  {
    id: "silent-witness",
    title: "沉默的证人",
    category: "suspense",
    region: "hk",
    year: "2026",
    status: "连载中",
    episodes: 60,
    updatedEpisode: 33,
    badge: "更新至33集",
    exclusive: false,
    rating: 9.1,
    views: "8200万",
    viewsNumber: 82000000,
    tags: ["刑侦", "法医", "连环案", "烧脑"],
    director: "方启明",
    cast: ["程未然", "骆一鸣", "何静"],
    synopsis:
      "法医程未然在一具无名尸体上发现了七年前旧案的标记。当所有证据都指向一个已经死了的人，她决定用自己的方式，让尸体开口说话。",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20suspense%20vertical%20poster%2C%20forensic%20investigator%20in%20a%20white%20coat%20under%20a%20flickering%20corridor%20light%2C%20evidence%20bags%2C%20deep%20shadows%2C%20desaturated%20cold%20tones%20with%20a%20single%20amber%20lamp%2C%20crime%20thriller%20key%20art&width=600&height=800&seq=drama-silent-witness&orientation=portrait",
    publishedAt: "2026-10-18",
  },
  {
    id: "love-formula",
    title: "恋爱公式",
    category: "sweet",
    region: "jpkr",
    year: "2026",
    status: "已完结",
    episodes: 58,
    updatedEpisode: 58,
    badge: "58集全",
    exclusive: false,
    rating: 8.6,
    views: "6700万",
    viewsNumber: 67000000,
    tags: ["办公室", "日久生情", "治愈", "轻喜"],
    director: "森川怜",
    cast: ["林知夏", "周予安", "小野"],
    synopsis:
      "理性派数据分析师林知夏坚信恋爱可以用公式计算，直到她被安排与全公司最难搞的产品经理同组。三个月的项目期，公式全部失效。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20romantic%20vertical%20poster%2C%20two%20young%20office%20workers%20sharing%20an%20umbrella%20on%20a%20rooftop%20at%20dusk%2C%20city%20lights%20below%2C%20warm%20tungsten%20glow%2C%20rain%20sparks%2C%20modern%20romance%20drama%20key%20art&width=600&height=800&seq=drama-love-formula&orientation=portrait",
    publishedAt: "2026-09-08",
  },
];

export type HeroSlide = {
  id: string;
  kicker: string;
  slogan: string;
  image: string;
};

export const heroSlides: HeroSlide[] = [
  {
    id: "ceo-substitute-bride",
    kicker: "本周巨献 · 全网独播",
    slogan: "一纸契约，换她三年替身；一朝心动，赔他半生痴缠。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20still%2C%20luxurious%20penthouse%20office%20at%20night%20with%20floor%20to%20ceiling%20city%20skyline%2C%20handsome%20CEO%20silhouette%20facing%20the%20window%2C%20crimson%20and%20amber%20ambient%20light%2C%20rain%20on%20glass%2C%20blockbuster%20drama%20key%20visual%2C%20wide%20landscape%20composition&width=1920&height=1080&seq=hero-juyan-ceo-penthouse&orientation=landscape",
  },
  {
    id: "war-god-return",
    kicker: "燃向推荐 · 5.1 亿次播放",
    slogan: "北境十年无人识，归来仍是少年郎。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20still%2C%20ancient%20Chinese%20battlefield%20at%20dawn%20with%20a%20warrior%20in%20black%20armor%20holding%20a%20spear%2C%20smoke%20and%20embers%2C%20golden%20sunrise%2C%20army%20banners%20in%20the%20distance%2C%20historical%20war%20drama%20key%20visual%2C%20wide%20landscape%20composition&width=1920&height=1080&seq=hero-juyan-battlefield&orientation=landscape",
  },
  {
    id: "silent-witness",
    kicker: "高能悬疑 · 评分 9.1",
    slogan: "尸体不会说谎，说谎的是还活着的人。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20still%2C%20neon%20lit%20rainy%20city%20street%20at%20night%2C%20mysterious%20man%20in%20a%20long%20coat%20walking%20toward%20camera%2C%20reflections%20on%20wet%20pavement%2C%20teal%20and%20gold%20cinematic%20lighting%2C%20thriller%20drama%20key%20visual%2C%20wide%20landscape%20composition&width=1920&height=1080&seq=hero-juyan-neon-street&orientation=landscape",
  },
];